export const WALLET = '/wallet'
export const USER = '/user'
export const SYSTEM = '/system'
export const MARKET = '/market'
export const USER_MARKET = '/userMarket'
export const CRYPTO_PRICE = '/crypto-price'

const NAMESPACES = {
  DEMO: '/demo',
  CRASH_GAME: '/crash-game',
  WALLET,
  USER,
  SYSTEM,
  MARKET,
  USER_MARKET,
  LIVE_WINS: '/live-wins',
  LIVE_CHATS: '/live-chats',
  ROLLER_COASTER_GAME: '/roller-coaster-game',
  CRYPTO_FUTURE: '/crypto-futures',
  ANNOUNCEMENT: '/announcement',
  MINE_GAME: '/mine-game',
  PLINKO_GAME: '/plinko-game',
  KYC: '/kyc-verification',
  TOTAL_BONUS_AMOUNTS: '/bonus',
  RANKING: '/ranking-level',
  WAGERING: '/wagering',
  CRYPTO_LOTTERY: '/crypto-lottery'
}

export default NAMESPACES
